import { useMutation } from '@tanstack/react-query';
import { deleteWallet } from '../walletsService';

interface useDeleteWalletVariables {
  id?: string;
}

export const useDeleteWallet = () => {
  return useMutation({
    mutationFn: async ({ id }: useDeleteWalletVariables) => {
      if (id) {
        return deleteWallet(id);
      }
    },
  });
};
